module.exports = __webpack_public_path__ + "img/logo-174x29.7fa19157.png";